const NL = /\n/

export const cleanOCRText = (text) => {
  text = text.replace(NL, '')
  text = text.replace(/ +(?= )/g, '')
  return text
}
